import {useState, useEffect, useReducer} from 'react';
import ccFetch from '../Helpers/ccFetch';

var OFFSET = 30;

var initialState = {
  // pg: null,
  reload: false,
  isLoading: false, //true
  isFinished: false,
  // hasMore: false,
  error: null,
  data: undefined
}

function reducer(state, action) {
  switch (action.type) {
    case 'download_init':
      return { ...state, isFinished: false, isLoading: true }
    case 'download_success':
      return {
        ...state,
        reload: false,
        isLoading: false,
        isFinished: true,
        data: action.data
      }
    case 'download_failed':
      return {
        ...state, 
        reload: false,
        isLoading: false,
        isFinished: true,
        data: null,
        error: action.error
      }
    case 'refresh':
      return { ...state, reload: true }
  }
}


const useFetchData = (url, opts={}) => {
  const {
    params={},
    opt={},
    reload:reload_=false,
    p,
  } = opts;
  const [ state, dispatch ] = useReducer(reducer, { ...initialState, reload: reload_ })
  const [pg, setPg] = useState(p)
  const [hasMore, setHasMore] = useState(false)
  const { reload, isLoading, isFinished, error, data } = state;
  const refresh = () => { dispatch({ type: 'refresh' }) }
  useEffect(() => {
    let uriAfter = postUri(params, pg);
    let url_ = url + uriAfter;
    dispatch({ type: 'download_init' })
    ccFetch(url_, opt)
      .then(res => res.json())
      .then(function (res) {
        dispatch({ 
          type: 'download_success', 
          data: (pg > 1) ? [...state.data, ...res] : res 
        })
      })
      .catch(err => {
        console.error(err)
        dispatch({ type: 'download_failed', error: err })
      })
  }, [url,reload,pg])
  useEffect(() => {
    if (data) {
      setHasMore(pg && (data.length === pg * OFFSET));
    }
  }, [data])
  let next = hasMore && (() => setPg(pg => pg + 1));
  return {
    isLoading,
    isFinished,
    error,
    data,
    refresh,
    hasMore,
    next,
  }
}

export default useFetchData


function postUri (params, p) {
  let _params = Object.entries(params);
  if (!_params.length && !p) return "";
  let urlPrefix = "?"
  urlPrefix = urlPrefix + (_params.length ? (
    _params.map(([k,v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&')
  ) : "" );
  if (p) urlPrefix = `${urlPrefix}&p=${p}`
  return urlPrefix;
}